import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

import { useState } from 'react';
import { Link as RouterLink, useLocation, useParams, useNavigate, useNavigation } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Container, Fab, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { BaseURL } from '../../common/URLs';
import { Constants } from 'ag-grid-community';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import Badge from 'react-bootstrap/Badge';
import { toast } from 'react-toastify';
import { VALIDATION, capitalizeFunction } from '../../common/commonValidations';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { HELPDESK_ROLES } from '../../common/constants';
import { loaderService } from '../../common/custom-loader/loader-service';
import apiClient from '../../axios';

function EditPage() {
    const auth = 'Bearer ' + getLocalStorageItem('id_token');
    const location = useLocation();
    const { id } = useParams();
    // const history = useNavigation();

    const [Flag, setFlag] = useState(null);

    const [isSubDisbaled, setSubDisabled] = useState(true);
    const [isSubCatSelected, setIsSubCatSelected] = useState(false);
    const [getCategory, setCategory] = useState(" ");
    const [getSubCat, setSubCatName] = useState(" ");

    const [respData, setRespData] = useState([]);
    const [resp1Data, setResp1Data] = useState([])
    const navigate = useNavigate();
    const [answer, setAnswer] = useState('');
    const [catsub, setCatsub] = useState([]);
    const [characterLimit] = useState(200);
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const [question, setQuestion] = useState('');
     const [isApiCalled, setIsApiCalled] = useState(false);

    const handleChangedquestion = (event) => {
        setQuestion(VALIDATION.noSpecialCharacterValidation(event.target.value));
    };

    const handleChangedanswer = (event) => {
        setAnswer(VALIDATION.noSpecialCharacterValidation(event.target.value));
    };
    //Code for getting sub-category from category
    function handleCategoryChange(e) {

        setCategory(e.target.value);
        setSubDisabled(false);
        setIsSubCatSelected(false);
        setFaq([]);
        //setCategory(getCategory) 
    }


    function handleSubCategoryChange(e) {
        // setOpen(e)
        setSubCatName(e.target.value);
        setIsSubCatSelected(true);

    }
    ///////////////////////////////////////////////


    useEffect(() => {
        //managefaq()
        fetchCatagory();

    }, [])
    useEffect(() => {
        managefaq()

        //  console.log(faqDetails)
    }, [id])


    //fetchCategoryAndSubcategory API
    const fetchCatagory = () => {
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchCategoryAndSubcategory",
            {},
            {
                headers: {
                    "Authorization": auth,
                    "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? true : false
                },
            }
        ).then((response) => {
            // console.log("Success - ", response);
            setRespData(response.data);
            loaderService.hideLoader();
            // console.log(respData, "responseData");

        }).catch((error) => {
            console.log("Error - " + error);
            loaderService.hideLoader();
        })
    }

    //edity API
    const editrequest = () => {
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/editHelpdeskFrequentAskQuestionById",

            {
                "id": id,
                "fqaQuestion": question,
                "fqaAnswer": answer,
                "grievanceCategory": getCategory,
                "grevanceSubCategory": getSubCat,
                "isActive": "Y",
                "crtdOn": "2022-12-23T09:55:58.434Z",
                "updtdOn": new Date().toISOString(),
                "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0
            },


            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            setRespData(response.data);
           response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description)
            navigate('../manage-faq')
            setResp1Data(response.data)
        }).catch((error) => {
            console.log("Error - " + error);
        })
    }

    ////////get the api data
    const managefaq = () => {
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpdeskFrequentAskQuestion",

            {

            },

            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            //  console.log("Success yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy - ", response);
            setCatsub(response.data)
            // setFaqArray(response.data.find(item => item.id === id));
            const faqDetails = response.data.find(item => item.id === id)
            setQuestion(faqDetails.fqaQuestion)
            setCategory(faqDetails.grievanceCategory)
            setSubCatName(faqDetails.grevanceSubCategory)
            //   setSubCatnewName(faqDetails.grevanceSubCategory)
            console.log(faqDetails);
            console.log(getSubCat, '-----update subcat');
            // console.log(getSubCatnew,'new update');
            setAnswer(faqDetails.fqaAnswer)
            setFlag(faqDetails)



            // console.log(faqDetails, "res-------------------");

        }).catch((error) => {
            console.log("Error - " + error);
        })
    }


// const onConfirmSubmit = () => {
//     handleConfirmLogModalClose()
//     editrequest()
// }

const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await editrequest();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen(false);
            setIsApiCalled(false);
        }
    };



    function submit() {

        var regex = /[-’/`~!#*$@_%+=.^&(){}[\]|;:”<>?\\]/g;
        // console.log(regex.test(question),'eeeeeeeeeeeeeeeeeeee');
        // if (regex.test(question) || regex.test(answer)) {
        //     toast.error('please do not use any special chreacter');
        // }
        if (question.length > 200 ) {
            toast.error('please enter the question within 200 words');
        }

        else if (answer.length > 200) {
            toast('please enter the answer within 200 words')
        }

        else {
handleConfirmLogModalOpen();
            
        }


    }




    const [getFaq, setFaq] = useState([])
    const helpTopics = [...getFaq];



    const categoryList = localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? respData?.External_category : respData?.Helpdesk_category

    return (
        <>
            <Helmet>
                <title> ManageFaqEdit/Add | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">

                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='../manage-faq' size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>  Manage FAQ
                </Typography>
                <Card sx={{ paddingLeft: '4%' }}>
                    <Stack spacing={2} sx={{ pt: 1 }}>


                        <FormControl >
                            <InputLabel id="select-category-label">Category</InputLabel>
                            <Select
                                labelId="select-category-label"
                                id="select-category"
                                label="category"

                                defaultValue={getCategory}
                                //  defaultValue={FaqArray.grievanceCategory}
                                value={getCategory}
                                onChange={handleCategoryChange}
                            //onClick={() => fetchCategory()}
                            >

                                <MenuItem value="">
                                    <em>Select</em>
                                </MenuItem>
                                {categoryList?.map(function (categoryList, i) {
                                    return <MenuItem key={categoryList} value={categoryList}>{categoryList}</MenuItem>
                                })}

                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '30%' }}>

                            <InputLabel id="select-subCategory-label"> Sub-Category</InputLabel>
                            <Select
                                labelId="select-subCategory-label"
                                id="select-subCategory"
                                label="Sub-Category"
                                defaultValue={getSubCat}
                                value={getSubCat}
                                onChange={handleSubCategoryChange}
                            >

                                {respData && respData[`${getCategory}`]?.map(function (subcat, i) {
                                    return <MenuItem key={subcat} value={subcat}>
                                        {subcat}</MenuItem>
                                })}

                            </Select>

                        </FormControl>



                        <TextField fullWidth
                            autoComplete="off"
                            //  id="outlined-multiline-static"
                            label="Question"
                            multiline
                            color="info"
                            rows={5}
                            onChange={handleChangedquestion}

                            value={question}

                            sx={{ paddingRight: '15%' }}
                        />
                        <div style={{display:'flex',justifyContent:'flex-end',paddingRight:'10%'}}>
                        <Badge  bg={`${question.length > characterLimit ? 'danger' : 'primary'}`}>{question.length}/{characterLimit}</Badge>
                        </div>
                        <TextField fullWidth
                            autoComplete="off"
                            maxLength={10}
                            //  id="outlined-multiline-static"
                            label="Answer"
                            multiline
                            color="info"
                            rows={5}
                            onChange={handleChangedanswer}
                            value={answer}

                            sx={{ paddingRight: '15%' }}
                        />
                         <div style={{display:'flex',justifyContent:'flex-end',paddingRight:'10%'}}>
                        <Badge  bg={`${answer.length > characterLimit ? 'danger' : 'primary'}`}>{answer.length}/{characterLimit}</Badge>
                        </div>
                    </Stack>
                    &nbsp;
                    &nbsp;
                    <Box display='flex' alignItems="center" justifyContent="center">
                        <Button sx={{ minWidth: 120 }} variant="contained" onClick={() => { submit() }}>Submit</Button>
                        &nbsp;
                        &nbsp;
                        <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined" component={RouterLink} to='../manage-faq'>Cancel</Button>

                    </Box>
                    &nbsp;
                    &nbsp;
                </Card>

            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />
         </>
    )
}

export default EditPage